<template>
	<div>
		<div
			class="modal fade"
			id="selectTemplate"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
		<div class="modal-dialog modal-lg" role="document">
			<div
				class="modal-content campaign-g-addedit"
				style="width:1000px;height:260px;margin-left:-49px"
			>
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLongTitle">Select Template</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click = "hideModal('cancel')">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body" style ="padding-top :25px" v-if="isLoadingData">
					<div
					class="spinner-border"
					style="margin:40px auto;display:block;"
					></div>
				</div>
				<div class="modal-body" style="margin-top:25px" v-else>
					<div class="form-group row">
						<div class="col-md-3">
							<label for="name">Template</label>
						</div>
						<div class = "col-md-6">
							<multiselect
								v-model="template"
								:options="template_list"
								:searchable="true"
								ref="multiselect"
								label="title"
								track-by="title"
								open-direction="bottom"
								:disabled = "temp == 'Edit'"
								placeholder="Selct template..."
								class="form-control multi-dropdown col-md-12"
								:multiple="false"
								id="keywordTags"
									>
							</multiselect>
						</div>
						<div class = "col-md-2" v-if = "template">
							<div v-if = "temp == 'Loading'" class="spinner-border"></div>
							<button
								v-else
								style="color:white;"
								id="delete"
								class="btn btn-primary"
								v-on:click="saveTemplate()"
							>{{temp}}</button>
						</div>
					</div>
				</div>

				<div class="modal-footer">
					<div class="mt-2" style="text-align: center">
						<!-- <button type="button" @click="hideModal('cancel')" class="btn btn-secondary" data-dismiss="modal">D</button> -->
						<button
							type="button"
							class="btn btn-primary"
							@click = "hideModal()"
							>Close
						</button>
					</div>
				</div>
		 </div>
	  </div>
	</div>
  </div>
</template>

<script>

import Multiselect from "vue-multiselect";

	export default {
		name: "SelectTemplate",
		components: {
			Multiselect
		},
		props:["templateSelected", "oldTemplate"],
		data() {
			return {
				isLoadingData:false,
				template:null,
				template_list:[],
				temp:'Add',
				addedRes:{}
			}
		},
		watch:{
			oldTemplate(){
				if(this.oldTemplate){
					this.editTemplate()
				}
			}
		},
		mounted() {
			this.getTemplateList()
		},
		methods: {
			hideModal(val){
				this.template = null;
				this.temp = 'Add'
				this.$emit("closeSelecTemplate", val, this.addedRes)
			},
			getTemplateList(){
				let vm = this;
				this.$store.dispatch("template/getTemplateList").then((res) => {
					vm.template_list = res
				})
			},
			saveTemplate(){
				let vm = this;
				
				if(this.temp == 'Edit'){
					this.temp = 'Add'
				}
				else{

					this.temp  = 'Loading';
					let payload = {
						guardrailId : this.templateSelected,
						templateId : this.template.id,
						templateName: this.template.title
					}
					this.$store.dispatch("automation/saveTemplateForGuardrail", payload).then((res) => {
						this.temp  = 'Edit';
						this.addedRes = res
					})
				}
			},
			editTemplate(){
				let payload = {
					id:this.oldTemplate
				}
				this.isLoadingData = true
				let vm = this;
				this.$store.dispatch("template/getTemplate", payload).then((res) => {
					this.temp = 'Edit'
					vm.template = res;
					this.isLoadingData = false
				})
			}
		}
	}

</script>
